module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp1_9016.18063422.png";